module.exports = __webpack_public_path__ + "img/edge_restauration_crepe.da1bb7ec.svg";